/**
 * An enum corresponding to values appropriate for Android's [`Notification#priority`](https://developer.android.com/reference/android/app/Notification#priority) field.
 */
export var AndroidNotificationPriority;
(function (AndroidNotificationPriority) {
    AndroidNotificationPriority["MIN"] = "min";
    AndroidNotificationPriority["LOW"] = "low";
    AndroidNotificationPriority["DEFAULT"] = "default";
    AndroidNotificationPriority["HIGH"] = "high";
    AndroidNotificationPriority["MAX"] = "max";
})(AndroidNotificationPriority || (AndroidNotificationPriority = {}));
//# sourceMappingURL=Notifications.types.js.map